module.exports = __webpack_public_path__ + "img/donation-check.0b25879a.svg";